<template>
  <div>
    <h2 class="mt-6 mb-6">機器基本資料</h2>

    <div class="row mb-3">
      <div class="col-12 col-md-6">
        <v-simple-table>
          <tbody>
            <tr>
              <td>連線狀態</td>
              <td>
                <template v-if="tempData.machine.online">
                  <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>連線
                </template>
                <template v-else>
                  <v-icon color="blue-grey lighten-3" class="mr-3">mdi-checkbox-blank-circle-outline</v-icon>離線
                </template>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <div class="col-12 col-md-6">
        <v-simple-table>
          <tbody>
            <tr>
              <td>設備狀態</td>
              <td>
                <template v-if="tempData.machine.malfunction">
                  <v-icon color="red" class="mr-3">mdi-checkbox-blank-circle</v-icon>異常
                </template>
                <template v-else>
                  <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>正常
                </template>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>

    <v-form v-model="valid">
      <v-card-text>
        <v-text-field
          v-model="tempData.machine.serial_number"
          label="機器序號"
          outlined
          readonly
          disabled
        ></v-text-field>
        <v-text-field v-model="tempData.machine.name" :rules="[formRules.required]" label="機器名稱" outlined></v-text-field>
        <div class="row">
          <div class="col-6 col-md-3 py-0">
            <v-select
              v-model="tempData.city_district.city"
              @change="cityDistrictChange"
              :items="Object.keys(city_districts)"
              :rules="[formRules.required]"
              placeholder="縣市"
              outlined
            ></v-select>
          </div>
          <div class="col-6 col-md-3 py-0">
            <v-select
              v-model="tempData.city_district.city_district_id"
              :readonly="!$district.length"
              :items="$district"
              item-text="district"
              item-value="city_district_id"
              :rules="[formRules.required]"
              placeholder="鄉鎮市區"
              outlined
            ></v-select>
          </div>
        </div>
        <v-text-field v-model="tempData.machine.address" :rules="[formRules.required]" label="地址" outlined></v-text-field>
        <v-text-field v-model="tempData.machine.version" :rules="[formRules.required]" label="版本" outlined></v-text-field>
      </v-card-text>

      <div class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" :disabled="!valid" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更機器基本資料？" text />
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import systemApi from "@/api/system";
import machineApi from "@/api/machine";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [],

  props: ["id"],
  data() {
    return {
      city_districts: {},
      machine: {
        city_district: {},
        machine: {}
      },
      tempData: {
        city_district: {},
        machine: {}
      },

      dialog: false,

      valid: false
    };
  },

  computed: {
    $district() {
      return this.city_districts[this.tempData.city_district.city] || [];
    }
  },
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      const machine = {
        city_district: res.city_district,
        machine: res.machine
      };

      this.machine = JSON.parse(JSON.stringify(machine));
      this.tempData = JSON.parse(JSON.stringify(machine));
    },

    cityDistrictChange() {
      this.tempData.city_district.city_district_id = 0;
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.machine));
    },

    submit() {
      machineApi
        .updateInfo(this.id, {
          name: this.tempData.machine.name,
          city_district_id: this.tempData.city_district.city_district_id,
          address: this.tempData.machine.address,
          version: this.tempData.machine.version
        })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });

            this.reset();
          } else {
            this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    systemApi
      .getCityDistricts()
      .then(res => {
        this.city_districts = res.city_districts;
      })
      .catch(err => {});

    machineApi
      .getInfo(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
